import { ITranslations } from '../models/common/ITranslations';
import { replacePlaceholders } from '../utils/replacePlaceholders';

export class TranslationHelper {
	targetTranslations: ITranslations = {};
	fallbackTranslations: ITranslations = {};
	constructor(targetTranslations: ITranslations, fallbackTranslations: ITranslations) {
		this.targetTranslations = targetTranslations;
		this.fallbackTranslations = fallbackTranslations;
		this.translate = this.translate.bind(this);
	}
	translate(key: string, placeholders?: any) {
		const translation = this.getTranslation(key);
		return placeholders
			? replacePlaceholders(placeholders, translation)
			: translation;
	}
	getTranslation(key: string) {
		return this.targetTranslations[key] || this.fallbackTranslations[key] || key;
	}
}